"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseDocument = void 0;
var types_1 = require("../../types");
exports.baseDocument = {
    dateCreated: "2021-09-27T20:16:29.796Z",
    form: {
        displayConditions: [
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227608,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227152,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227801,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227457,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227607,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227155,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227803,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227154,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227603,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227452,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227804,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227454,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227805,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227156,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227602,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227456,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227802,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227153,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227606,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227458,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227605,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227453,
                targetType: "QUESTION",
            },
            {
                action: "PREFILL",
                booleanCondition: null,
                id: 1227604,
                parentWidgetId: null,
                prefillAnswerField: "value",
                prefillAssociatedIdField: "",
                prefillAssociatedLocation: null,
                sourceConditionRootId: null,
                sourceQuestionRootId: 1227151,
                targetRootId: 1227455,
                targetType: "QUESTION",
            },
        ],
        id: 1226951,
        name: "Dropdown Prefills",
        rootId: 1226951,
        sections: [
            {
                id: 1227051,
                items: [
                    {
                        answerSource: {
                            dataSourceKey: "PARTICIPANT",
                            id: 1227651,
                            isFromWidget: null,
                            properties: {
                                answerField: "fullName",
                                autoComplete: false,
                                detailedSearch: {
                                    title: "Add Participant",
                                    enabled: true,
                                    linkName: "Add Participant",
                                    searchBy: "Search by name or member ID",
                                    subtitle: "Who would you like to add?",
                                    infiniteListTitle: "Participants by Alphabetical Order",
                                    infiniteListSortBy: "fullName",
                                    recentAnswersTitle: "Recently Added Participants",
                                    customAnswerEnabled: true,
                                    infiniteListEnabled: true,
                                    recentAnswersEnabled: true,
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        formProperties: {
                            id: 1227252,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227152,
                        },
                        hasDefenses: false,
                        id: 1227152,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.636477Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: "ATTENDANT",
                        properties: null,
                        rootId: 1227152,
                        selections: [],
                        subType: "PARTICIPANT",
                        tags: [],
                        title: "Participant",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "123423",
                            id: 1227652,
                            isFromWidget: null,
                            properties: {
                                answerField: "value",
                                autoComplete: false,
                                dataSourceId: 570751,
                                detailedSearch: {
                                    infiniteListSortBy: "displayOrder,value",
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        formProperties: {
                            id: 1227253,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227153,
                        },
                        hasDefenses: false,
                        id: 1227153,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.646949Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1227153,
                        selections: [],
                        subType: "MULTI_SELECT",
                        tags: [],
                        title: "Same data set (multi select)",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1227557,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227457,
                        },
                        hasDefenses: false,
                        id: 1227457,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.656235Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: {},
                        rootId: 1227457,
                        selections: [
                            {
                                defenseIds: [],
                                id: 1227701,
                                rootId: 0,
                                tags: [],
                                title: "value 1",
                            },
                            {
                                defenseIds: [],
                                id: 1227702,
                                rootId: 0,
                                tags: [],
                                title: "value 2",
                            },
                            {
                                defenseIds: [],
                                id: 1227703,
                                rootId: 0,
                                tags: [],
                                title: "green",
                            },
                        ],
                        subType: "MULTI_SELECT",
                        tags: [],
                        title: "Different data set (multi select)",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "123423",
                            id: 1227653,
                            isFromWidget: null,
                            properties: {
                                answerField: "value",
                                autoComplete: false,
                                dataSourceId: 570751,
                                detailedSearch: {
                                    infiniteListSortBy: "displayOrder,value",
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        formProperties: {
                            id: 1227552,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227452,
                        },
                        hasDefenses: false,
                        id: 1227452,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.667698Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1227452,
                        selections: [],
                        subType: "RADIO_BUTTONS",
                        tags: [],
                        title: "Same data set (radio)",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1227256,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227156,
                        },
                        hasDefenses: false,
                        id: 1227156,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.682515Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: {},
                        rootId: 1227156,
                        selections: [
                            {
                                defenseIds: [],
                                id: 1227703,
                                rootId: 0,
                                tags: [],
                                title: "value 1",
                            },
                            {
                                defenseIds: [],
                                id: 1227704,
                                rootId: 0,
                                tags: [],
                                title: "value 2",
                            },
                        ],
                        subType: "RADIO_BUTTONS",
                        tags: [],
                        title: "Different data set (radio)",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1227254,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227154,
                        },
                        hasDefenses: false,
                        id: 1227154,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.734745Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1227154,
                        selections: [],
                        subType: "YES_OR_NO",
                        tags: [],
                        title: "yes/no",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: {
                            dataSourceKey: "123423",
                            id: 1227654,
                            isFromWidget: null,
                            properties: {
                                answerField: "value",
                                autoComplete: false,
                                dataSourceId: 570751,
                                detailedSearch: {
                                    infiniteListSortBy: "displayOrder,value",
                                },
                            },
                            type: "DATA_SOURCE",
                        },
                        formProperties: {
                            id: 1227255,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227155,
                        },
                        hasDefenses: false,
                        id: 1227155,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.746822Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1227155,
                        selections: [],
                        subType: "DROP_DOWN",
                        tags: [],
                        title: "Same data set (dropdown)",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1227558,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227458,
                        },
                        hasDefenses: false,
                        id: 1227458,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.755919Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: {},
                        rootId: 1227458,
                        selections: [
                            {
                                defenseIds: [],
                                id: 1227705,
                                rootId: 0,
                                tags: [],
                                title: "value 1",
                            },
                            {
                                defenseIds: [],
                                id: 1227706,
                                rootId: 0,
                                tags: [],
                                title: "value 2",
                            },
                        ],
                        subType: "DROP_DOWN",
                        tags: [],
                        title: "Different data set (dropdown)",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1227553,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227453,
                        },
                        hasDefenses: false,
                        id: 1227453,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.768449Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1227453,
                        selections: [],
                        subType: "TEXT_LINE",
                        tags: [],
                        title: "Single line",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1227554,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227454,
                        },
                        hasDefenses: false,
                        id: 1227454,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.775455Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1227454,
                        selections: [],
                        subType: "TEXT_AREA",
                        tags: [],
                        title: "Paragraph",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1227555,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227455,
                        },
                        hasDefenses: false,
                        id: 1227455,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.839340Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1227455,
                        selections: [],
                        subType: "DATE",
                        tags: [],
                        title: "Date",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                    {
                        answerSource: null,
                        formProperties: {
                            id: 1227556,
                            isCloneable: true,
                            isRequired: false,
                            isSearchable: false,
                            questionRootId: 1227456,
                        },
                        hasDefenses: false,
                        id: 1227456,
                        isGlobalQuestion: false,
                        lastModifiedDate: "2021-09-27T19:53:09.847247Z",
                        parentWidgetRootId: null,
                        parentWidgetSelectionRootId: null,
                        participantRole: null,
                        properties: null,
                        rootId: 1227456,
                        selections: [],
                        subType: "TIME",
                        tags: [],
                        title: "Time",
                        type: "QUESTION",
                        validations: [],
                        workflowType: "FINAL",
                    },
                ],
                parentWidgetRootId: null,
                properties: null,
                rootId: 1227051,
                title: "Basic Data Set Dropdown",
                workflowType: "FINAL",
            },
        ],
        type: {
            active: true,
            id: 1216350,
            name: "Todd's Forms",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    formActionRequests: [],
    formSummary: {
        id: 1226951,
        name: "Dropdown Prefills",
        rootId: 1226951,
        type: {
            active: true,
            id: 1216350,
            name: "Todd's Forms",
            isGlobal: true,
        },
        workflowType: "FINAL",
    },
    id: 1228002,
    isRehuddle: false,
    operationalExperiences: [],
    owner: {
        fullName: 'Riley, Todd "Client Admin"',
        name: "Todd Riley",
        participantId: 1062103,
    },
    ownerId: 1062103,
    parentId: null,
    participants: [],
    photos: [],
    readOnly: false,
    responses: [],
    resubmissions: [],
    sectionComments: [],
    startDate: "2021-09-27T20:16:29.796Z",
    status: types_1.DocumentStatus.IN_PROGRESS,
    submissionDate: "2021-09-27T20:16:33.474Z",
    submissionId: 1228052,
    submissionType: types_1.DocumentSubmissionType.NEW,
    summary: {},
    title: "New Document",
    workOrder: null,
};
//# sourceMappingURL=baseDocument.js.map